import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/animations/alerts/alerta-loading.json'; // Asegúrate de usar la ruta correcta

const LoadingModal = () => {
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);
  const modal = useRef<HTMLDivElement>(null);

  if (!isLoading) return null;

  return (
    <div className="fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
      <div
        ref={modal}
        className="border-gray-200 w-96 max-w-full rounded-2xl border bg-white p-6 shadow-2xl dark:border-strokedark dark:bg-boxdark sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
      >
        {/* Animación de carga Lottie */}
        <div className="mb-4 flex justify-center">
          <Lottie
            animationData={loadingAnimation}
            loop={true}
            style={{ width: 125, height: 125 }}
          />
        </div>

        <div className="flex flex-col items-center text-center">
          <h3 className="pb-2 text-xl font-bold text-black dark:text-white sm:text-2xl">
            Por favor espere...
          </h3>
          <p className="text-gray-800 dark:text-gray-300 mb-6">
            Estamos procesando su solicitud.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;
